import React from 'react';
import {
  Home,
  Heart,
  MessageSquare,
  Clock,
  User,
  Sun,
  ArrowRight,
  ChevronDown,
  Plus
} from 'lucide-react';

const bespokeSvgs = {
  diya: (
    <>
      <path d="M12 3.5c1.7 1.9 2.5 3.2 2.5 4.6a2.5 2.5 0 0 1-5 0c0-.9.4-1.7 1-2.5" />
      <path d="M4 13.2c1.7 2.4 4.6 3.8 8 3.8s6.3-1.4 8-3.8c-1.2.6-2.6 1-4 1H8c-1.4 0-2.8-.4-4-1z" />
      <path d="M12 17v2.5" />
    </>
  ),
  flame: (
    <>
      <path d="M12 3c3 3.5 4.5 6 4.5 8.5a4.5 4.5 0 0 1-9 0c0-1.2.4-2.3 1.2-3.5.6 1 1.3 1.6 2.1 1.8-.3-2 .1-4 1.2-6.8z" />
    </>
  ),
  lotus: (
    <>
      <path d="M12 4c1.4 2 2.1 4 2.1 6.5 0 1.2-.9 2.3-2.1 2.3s-2.1-1.1-2.1-2.3C9.9 8 10.6 6 12 4z" />
      <path d="M12 12.8c-1.3-1.6-3-2.6-5-3 .2 2 .9 3.6 2.3 4.7" />
      <path d="M12 12.8c1.3-1.6 3-2.6 5-3-.2 2-.9 3.6-2.3 4.7" />
      <path d="M5 13.5c1.5 2.5 4 4 7 4s5.5-1.5 7-4" />
    </>
  ),
  mandala: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="3.2" />
      <path d="M12 3.5v3.3M12 17.2v3.3M3.5 12h3.3M17.2 12h3.3M6 6l2.3 2.3M15.7 15.7 18 18M18 6l-2.3 2.3M8.3 15.7 6 18" />
    </>
  ),
  spark: (
    <>
      <path d="M12 3c.6 4.2 1.8 5.4 6 6-4.2.6-5.4 1.8-6 6-.6-4.2-1.8-5.4-6-6 4.2-.6 5.4-1.8 6-6z" />
    </>
  ),
  rings: (
    <>
      <circle cx="9" cy="13" r="5.5" />
      <circle cx="15" cy="13" r="5.5" />
      <path d="M9 5.5 12 3l3 2.5" />
    </>
  ),
  scroll: (
    <>
      <path d="M7 4h9a1 1 0 0 1 1 1v13a2 2 0 0 1-2 2H7" />
      <path d="M7 4a2 2 0 0 0-2 2a2 2 0 0 0 2 2h1V4z" />
      <path d="M17 20a2 2 0 0 0 2-2v-1h-4" />
      <path d="M10 9h4M10 12.5h4" />
    </>
  ),
  diamond: (
    <>
      <path d="M3 12 12 3l9 9-9 9z" />
      <path d="M3 12h18M12 3v18" />
    </>
  )
};

const lucideMap = {
  home: Home,
  heart: Heart,
  chat: MessageSquare,
  hora: Clock,
  account: User,
  horoscope: Sun,
  arrow: ArrowRight,
  chevron: ChevronDown,
  add: Plus
};

export default function Icon({ name, size = 24, className = '', style = {}, ...props }) {
  // Bespoke astrology SVGs
  if (bespokeSvgs[name]) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        style={style}
        {...props}
      >
        {bespokeSvgs[name]}
      </svg>
    );
  }

  // Lucide fallback
  const LucideIcon = lucideMap[name] || Home;
  return <LucideIcon size={size} className={className} style={style} {...props} />;
}
